import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { registerViaLink } from "../../services/publicSessionLinkService";
import { useAuth } from "../../context/AuthContext";
import "./sessionLanding.css";

const INITIAL = { name: "", email: "", mobile: "", countryCode: "+91", consentGiven: false, whatsappEnabled: false };

const RegistrationForm = ({ token, onOtpRequired }) => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(INITIAL);
  const [countryCodes, setCountryCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/public/country-codes`)
      .then((res) => setCountryCodes(res.data?.data || []))
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.consentGiven) { setError("Please agree to the Terms & Privacy Policy to continue."); return; }

    const payload = {
      name: form.name.trim(),
      email: form.email.trim(),
      mobile: form.mobile.trim(),
      countryCode: form.countryCode,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      consentGiven: form.consentGiven,
      whatsappEnabled: form.whatsappEnabled,
    };

    setLoading(true);
    const result = await registerViaLink(token, payload);
    setLoading(false);

    const data = result.data;
    if (data?.status === "SUCCESS") {
      login(data, data.jwtToken);
      navigate("/", { replace: true });
    } else if (data?.status === "OTP_REQUIRED") {
      onOtpRequired({ email: payload.email, userName: data.userName, message: data.message });
    } else {
      setError(data?.message || result.message || "Registration failed. Please try again.");
    }
  };

  return (
    <div className="sl-form-section">
      <h3>Register for this Session</h3>
      <form onSubmit={handleSubmit}>
        <div className="sl-field">
          <label>Full Name *</label>
          <input name="name" type="text" value={form.name} onChange={handleChange} placeholder="John Doe" required />
        </div>
        <div className="sl-field">
          <label>Email Address *</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="john@example.com" required />
        </div>
        <div className="sl-field">
          <label>Mobile Number *</label>
          <div className="sl-mobile-row">
            <select name="countryCode" value={form.countryCode} onChange={handleChange}>
              {countryCodes.length > 0
                ? countryCodes.map((c) => <option key={c.id} value={c.dialCode}>{c.isoCode} {c.dialCode}</option>)
                : <option value="+91">IN +91</option>}
            </select>
            <input
              name="mobile" type="tel" value={form.mobile}
              onChange={(e) => setForm((f) => ({ ...f, mobile: e.target.value.replace(/\D/g, "") }))}
              placeholder="9876543210" required maxLength={15}
            />
          </div>
        </div>
        <label className="sl-checkbox-row">
          <input type="checkbox" name="consentGiven" checked={form.consentGiven} onChange={handleChange} />
          <span>I agree to the <a href="/terms-and-conditions" target="_blank" rel="noreferrer">Terms &amp; Privacy Policy</a> *</span>
        </label>
        <label className="sl-checkbox-row">
          <input type="checkbox" name="whatsappEnabled" checked={form.whatsappEnabled} onChange={handleChange} />
          <span>Enable WhatsApp updates</span>
        </label>
        {error && <p className="sl-form-error">{error}</p>}
        <button type="submit" className="sl-submit-btn" disabled={loading}>
          {loading ? "Registering..." : "Register for Free 🚀"}
        </button>
      </form>
    </div>
  );
};

export default RegistrationForm;
